import ContactDirectory from "@/components/ContactDirectory";

export default function Distributors({ initialQuery = "" }) {
  return (
    <ContactDirectory
      initialQuery={initialQuery}
      title="Distributors"
      subtitle="Your distributor contact directory."
      endpoint="/distributors"
      prefix="distributor"
      singular="distributor"
      addLabel="Add distributor"
    />
  );
}
